export const FinalCTA = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-500 to-cyan-600 text-white">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
          Ready to Sell Your Mid-Rise Apartment Building?
        </h2>
        <p className="text-xl md:text-2xl mb-12 text-white/95 max-w-3xl mx-auto leading-relaxed">
          Get a fair cash offer in 48 hours. Close in 30-45 days. No repairs, no commissions, no hassle.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-12">
          <a 
            href="#get-offer" 
            className="whitespace-nowrap bg-white text-teal-600 px-10 py-5 rounded-lg text-xl font-semibold hover:bg-gray-100 transition-all duration-300 shadow-2xl hover:shadow-3xl cursor-pointer"
          >
            Get Your Cash Offer
          </a>
          <a 
            href="tel:+1234567890" 
            className="whitespace-nowrap bg-white/10 backdrop-blur-sm text-white px-10 py-5 rounded-lg text-xl font-semibold hover:bg-white/20 transition-all duration-300 border-2 border-white/30 cursor-pointer flex items-center"
          >
            <i className="ri-phone-line mr-3 text-2xl"></i>
            Call Us Now
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
              <i className="ri-time-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">Fast Response</h3>
            <p className="text-white/90">We respond to all inquiries within 24 hours</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">No Obligation</h3>
            <p className="text-white/90">Our offers are completely free with no commitment</p>
          </div>
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 border border-white/20">
            <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-lg mx-auto mb-4">
              <i className="ri-eye-off-line text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">Confidential</h3>
            <p className="text-white/90">Your information is kept completely private</p>
          </div>
        </div>
      </div>
    </section>
  );
};